export default __webpack_public_path__ + "assets/4d2b19dc33cdfdb6caee69c8325f63f1.png";